import { ALLINDICES_LIST, ALLINDICES_LIST_ERROR, ALLINDICES_LIST_HIDE_ERROR, ALLINDICES_LIST_START_LOADER, ALLINDICES_LIST_STOP_LOADER, } from "../interface/IAllIndicesList";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const AllIndicesListReducer = (state = initState, action) => {
    switch (action.type) {
        case ALLINDICES_LIST: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case ALLINDICES_LIST_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ALLINDICES_LIST_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case ALLINDICES_LIST_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ALLINDICES_LIST_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default AllIndicesListReducer;
